module.exports = "vec2 interpolation(float t, vec2 p1, vec2 p2, vec2 c1, vec2 c2) {\nreturn p1 + (p2 - p1) * t;\n}"